import { render } from "./ShipmentPage.vue?vue&type=template&id=eab2d71a&ts=true"
import script from "./ShipmentPage.vue?vue&type=script&lang=ts"
export * from "./ShipmentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__